// Underwriter-review API helpers: product endorsement list + navigating form posts (decline / refer / finalise).

function antiforgeryToken(): string {
    return (document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement | null)?.value ?? '';
}

// Endorsements configured for the product (System Admin → Endorsements). Fills the review "add endorsement" dropdown.
export async function GetProductEndorsements(productId: string): Promise<any[]> {
    const token = antiforgeryToken();
    const headers: Record<string, string> = { 'X-Requested-With': 'XMLHttpRequest' };
    const body = new URLSearchParams();
    if (token) { headers['RequestVerificationToken'] = token; body.set('__RequestVerificationToken', token); }
    try {
        const res = await fetch(`/systemadmin/endorsements/getallforproduct?productId=${productId}`, { method: 'POST', headers, body });
        if (!res.ok) return [];
        const text = await res.text();
        const data = text ? JSON.parse(text) : [];
        return Array.isArray(data) ? data : [];
    } catch (e) {
        console.error('GetProductEndorsements failed', e);
        return [];
    }
}

// Persist policy/scheme-level endorsements: post the whole ProductOutput to /updateproductoutput; the server copies scheme.Endorsements onto the saved output and returns it.
export async function UpdateProductOutput(action: string, productId: string, quoteId: string, productOutput: any): Promise<any | null> {
    const token = antiforgeryToken();
    const headers: Record<string, string> = { 'X-Requested-With': 'XMLHttpRequest' };
    const body = new URLSearchParams();
    body.set('quoteId', quoteId);
    body.set('productId', productId);
    body.set('action', action);
    body.set('cover', JSON.stringify(productOutput ?? {}));
    if (token) { headers['RequestVerificationToken'] = token; body.set('__RequestVerificationToken', token); }
    try {
        const res = await fetch(`/schemes/${productId}/updateproductoutput`, { method: 'POST', headers, body });
        if (!res.ok) return null;
        const text = await res.text();
        return text ? JSON.parse(text) : null;
    } catch (e) {
        console.error('UpdateProductOutput failed', e);
        return null;
    }
}

// Build and submit a hidden form so the browser navigates to the server response (decline/refer redirect, finalise → PrePurchase).
export function postNavigate(url: string, fields: Record<string, string>): void {
    const token = antiforgeryToken();
    const form = document.createElement('form');
    form.method = 'post';
    form.action = url;
    const all: Record<string, string> = { ...fields, ...(token ? { __RequestVerificationToken: token } : {}) };
    for (const [name, value] of Object.entries(all)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value ?? '';
        form.appendChild(input);
    }
    document.body.appendChild(form);
    (window as any).showLoader?.();
    form.submit();
}
